import defaultPalette from '../palette';
export default (function (_a) {
    var _b;
    var _c = _a.palette, palette = _c === void 0 ? defaultPalette : _c;
    return {
        MuiSwitch: {
            root: {
                '& $switchBase$checked': {
                    color: (_b = palette === null || palette === void 0 ? void 0 : palette.primary) === null || _b === void 0 ? void 0 : _b.light,
                },
                '& $switchBase$checked + $track': {
                    backgroundColor: palette === null || palette === void 0 ? void 0 : palette.primary[200],
                    opacity: 1,
                },
                '& $switchBase$checked$disabled': {
                    color: palette === null || palette === void 0 ? void 0 : palette.primary[200],
                },
                '& $switchBase$checked$disabled + $track': {
                    backgroundColor: palette === null || palette === void 0 ? void 0 : palette.primary[100],
                    opacity: 1,
                },
                '& $switchBase:not($checked)': {
                    color: palette === null || palette === void 0 ? void 0 : palette.grey[400],
                },
                '& $switchBase:not($checked) + $track': {
                    backgroundColor: palette === null || palette === void 0 ? void 0 : palette.grey[500],
                    opacity: 1,
                },
                '& $switchBase:not($checked)$disabled': {
                    color: palette === null || palette === void 0 ? void 0 : palette.grey[300],
                    opacity: 1,
                },
                '& $switchBase:not($checked)$disabled + $track': {
                    backgroundColor: palette === null || palette === void 0 ? void 0 : palette.grey[400],
                    opacity: 1,
                },
            },
        },
    };
});
